import AdvocateNithinDetails from '../../components/about/advocates-details/nithin';
import Footer from '../../components/common/footer';
import Layout from '../../components/common/layout';
import NavigationMenu from '../../components/common/navigationMenu';
import PageHeader from '../../components/common/pageHeader';
import React from 'react';

const AdvocateNithinDetailsPage = () => {
  return (
    <Layout pageTitle='Avadhani & Associates | Nithin Chowdary Pavuluri'>
      <NavigationMenu active='about' />
      <PageHeader
        title='Nithin Chowdary Pavuluri'
        subMenu='Advocates'
        backLink='/about#team-section'
      />
      <AdvocateNithinDetails />
      <Footer />
    </Layout>
  );
};

export default AdvocateNithinDetailsPage;
